import * as React from 'react';
import styled from 'styled-components';
import { ILayer } from '../../types/ILayer';
import { LayerUtils } from '../../util/LayerUtils';
import { layerGroupInfoFor } from '../../types/ELayerGroup';
import { runLabel } from '../../types/ILayer';

interface IProps {
  /** @ignore */
  className?: string;
  /** Layer to show */
  layer: ILayer;
}

const LayerCardBase = (props: IProps) => {
  return (
    <div className={props.className}>
      <Type>{LayerUtils.layerTypeToDefinition(props.layer.type).name}</Type>
      {/* Was the source filename, which only ever meant anything for layers
          imported from Excel -- ORGANIX results repeat the layer name here.
          LayerInfoBox still shows Source for the admin who needs it. */}
      <Group>
        {layerGroupInfoFor(props.layer.type).label}
        {props.layer.run && <> · {runLabel(props.layer.run)}</>}
      </Group>
    </div>
  )
}

const Type = styled.div`
  overflow-x: hidden;
  text-overflow: ellipsis;
`

const Group = styled.div`
  overflow-x: hidden;
  text-overflow: ellipsis;
  font-size: 80%;
`

const LayerCardStyled = styled(LayerCardBase)`
  display: flex;
  flex-direction: column;
`

const LayerCard = (props: IProps) => <LayerCardStyled {...props}/>

export { LayerCard }
